import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {CommonsModule} from "../../commons/angular/commons.module";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {NgxPermissionsModule} from "ngx-permissions";
import {BzButton, BzCheckbox, BzEmptyState, BzIcon, BzSkeleton, BzTable, BzTableHeaderDef, BzTableRowDef} from "@bringoz/ui";
import {OmsOrdersTableComponent} from "./components/oms-orders-table/oms-orders-table.component";
import {OmsOrdersTableRowComponent} from "./components/oms-orders-table-row/oms-orders-table-row.component";
import {AddressesModule} from "../../addresses/angular/addresses.module";
import {
  OmsOrderFulfillmentLineNotesComponent
} from "./components/oms-order-fulfillment-line-notes/oms-order-fulfillment-line-notes.component";
import {OmsOrderActionMenuComponent} from "./components/oms-order-action-menu/oms-order-action-menu.component";

@NgModule({
  declarations: [
    OmsOrdersTableComponent,
    OmsOrdersTableRowComponent,
    OmsOrderFulfillmentLineNotesComponent,
    OmsOrderActionMenuComponent
  ],
  imports: [
    BrowserModule,
    CommonsModule,
    NgbModule,
    AddressesModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild(),
    BzButton, BzCheckbox, BzEmptyState, BzIcon, BzSkeleton, BzTable, BzTableHeaderDef, BzTableRowDef
  ],
  providers: [],
  exports: []
})

export class OrdersModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapOrdersModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(OrdersModule);
};

export const downgradedOrdersModule = downgradeModule(bootstrapOrdersModule);
